import { useQuery } from '@tanstack/react-query';
import { fetchTrafficEvent, fetchTrafficEventTime } from '@/shared/apis/dashboard';
import type { UseTrafficEventParams, UseTrafficEventReturn } from '@/shared/types/traffic-event';

const defaultQueryOptions = {
  staleTime: 1000 * 60, // 1 minutes
  cacheTime: 1000 * 60 * 10, // 10 minutes
  refetchInterval: 1000 * 60, // 1 minute
  refetchIntervalInBackground: true,
};

const useTrafficEvent = ({
  id = '',
  trafficEventParams = '',
  trafficEventParamsCnt = '',
}: UseTrafficEventParams): UseTrafficEventReturn => {
  // 시간별 이벤트
  const { data: trafficEventTime } = useQuery({
    queryKey: ['trafficEventTime', trafficEventParams],
    queryFn: () => fetchTrafficEventTime(trafficEventParams),
    ...defaultQueryOptions,
    placeholderData: (prev) => prev,
    staleTime: 1000 * 60 * 1, // Override the default staleTime
  });

  // 이벤트 갯수
  const { data: trafficEventTimeCnt } = useQuery({
    queryKey: ['trafficEventTimeCnt', trafficEventParamsCnt],
    queryFn: () => fetchTrafficEventTime(trafficEventParamsCnt),
    ...defaultQueryOptions,
    placeholderData: (prev) => prev,
    staleTime: 1000 * 60 * 1, // Override the default staleTime
  });

  // 교통량 이벤트
  const { data: trafficEvent } = useQuery({
    queryKey: ['trafficEvent', id],
    queryFn: () => fetchTrafficEvent(id),
    retry: false,
    enabled: !!id,
    ...defaultQueryOptions,
    placeholderData: (prev) => prev,
    staleTime: 1000 * 60 * 1, // Override the default staleTime
  });

  return {
    trafficEventTime: trafficEventTime?.data,
    trafficEvent: trafficEvent?.data,
    trafficEventTimeCnt: trafficEventTimeCnt?.data,
  };
};

export default useTrafficEvent;
